import React, { useState , useMemo } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CustomSidePanel from "../../../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../../../components/button";
import * as accountRcsBotConfigActions from "../../../store/actions/account_rcs_bot_configs_actions";

export default function AccountRcsBotConfigSidePanel({ show, rcsBotConfigData, handleClose }) {
  
  const dispatch = useDispatch();
  const params = useParams();

  const formData = useMemo(() => ({
    botName: rcsBotConfigData?.botName || "",
    brandLogo: rcsBotConfigData?.brandLogo || ""
  }), [rcsBotConfigData]);

  const [localFormData, setLocalFormData] = useState(formData);

  useMemo(() => {
    setLocalFormData(formData);
  }, [formData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const payload = {
      accountId: params.accountId,
      data: {
        settingId: rcsBotConfigData._id,
        botName: localFormData.botName,
        brandLogo: localFormData.brandLogo
      },
    };
    dispatch(accountRcsBotConfigActions.updateRcsBotConfigRequest(payload));
    handleClose();
  };

  const handleChange = (inputKey, inputValue) => {
    setLocalFormData((prev) => ({
      ...prev,
      [inputKey]: inputValue,
    }));
  };

  return (
    <CustomSidePanel
      title={`Bot Name: ${rcsBotConfigData.botName}`}
      show={show}
      moduleName="RCS Bot Configuration"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >
      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{`Bot Name: ${rcsBotConfigData.botName}`}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <FormDisplay formData={localFormData} handleChange={handleChange} handleClose={handleClose} handleSubmit={handleSubmit} />
      </div>
    </CustomSidePanel>
  );
}

const FormDisplay = ({ formData, handleChange, handleClose, handleSubmit }) => {
 
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Bot Name</label>
          <Form.Control
            type="text"
            value={formData.botName}
            onChange={(e) => handleChange("botName", e.target.value)}
          />
        </Col>
        <Col className="form-group" xs={6}>
          <Form.Label>Brand Logo</Form.Label>
          <Form.Control
            type="text"
            value={formData.brandLogo}
            onChange={(e) => handleChange("brandLogo", e.target.value)}
          />
        </Col>
      </Row>

      <Form.Group className="d-flex gap-3 mt-10">
        <Button type="button" size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <BlueGradientButton size="sm" type="submit">
          Save
        </BlueGradientButton>
      </Form.Group>
    </Form>
  );
};
